function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-26"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 25.97,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.97,
    y: 391.01,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.71,
    y: 398.49,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 16.25,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.06,
    y: 390.89,
    width: 36.83,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.66,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.54,
    y: 87.83,
    width: 259.11,
    height: 156.78,
    transform: "translate(496.19 332.45) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.5,
    y: 87.83,
    width: 261.4,
    height: 156.78,
    transform: "translate(490.39 332.45) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.65,
    y: 42.78,
    width: 141.1,
    height: 246.88,
    transform: "translate(411.42 -78.97) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.11 236.77 295.95 95.68 273.57 95.68 326.73 236.77 349.11 236.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.38 236.77 267.23 95.68 251.81 95.68 304.97 236.77 320.38 236.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.47 236.77 173.31 95.68 157.9 95.68 211.06 236.77 226.47 236.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.04,
    y: 161.9,
    width: 141.1,
    height: 8.66,
    transform: "translate(345.81 -13.36) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.05,
    y: 161.9,
    width: 141.1,
    height: 8.66,
    transform: "translate(482.83 -150.38) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.93,
    y: 160.33,
    width: 151.9,
    height: 10.94,
    transform: "translate(342.68 -11.09) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.95,
    y: 160.33,
    width: 151.9,
    height: 10.94,
    transform: "translate(479.69 -148.1) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.59,
    y: 165.84,
    width: 141.1,
    height: 0.77,
    transform: "translate(288.36 44.09) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.51,
    y: 77.75,
    width: 275.97,
    height: 2,
    rx: 0.97,
    transform: "translate(496.99 157.5) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.65,81.55h0a1.27,1.27,0,0,0,1.27-1.26V77.21A1.27,1.27,0,0,0,377.65,76h0a1.27,1.27,0,0,0-1.26,1.26v3.08A1.27,1.27,0,0,0,377.65,81.55Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.56,81.55h0a1.27,1.27,0,0,0,1.27-1.26V77.21A1.27,1.27,0,0,0,125.56,76h0a1.27,1.27,0,0,0-1.26,1.26v3.08A1.27,1.27,0,0,0,125.56,81.55Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.75,
    y: 78.75,
    width: 261.27,
    height: 111.87,
    transform: "translate(484.76 269.36) rotate(180)",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.36,
    y: 240.01,
    width: 119.3,
    height: 165.48,
    transform: "translate(477.76 167.74) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.53,
    y: 210.42,
    width: 34.97,
    height: 147.31,
    transform: "translate(439.09 129.06) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.53,
    y: 248.52,
    width: 34.97,
    height: 147.31,
    transform: "translate(477.19 167.17) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.53,
    y: 286.63,
    width: 34.97,
    height: 147.31,
    transform: "translate(515.3 205.27) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.62,266.13H122.41a3.62,3.62,0,0,0,3.62,3.62h58A3.63,3.63,0,0,0,187.62,266.13Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.62,304.23H122.41a3.62,3.62,0,0,0,3.62,3.63h58A3.63,3.63,0,0,0,187.62,304.23Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.62,342.34H122.41A3.62,3.62,0,0,0,126,346h58A3.63,3.63,0,0,0,187.62,342.34Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.43,
    y: 314.42,
    width: 119.3,
    height: 16.66,
    transform: "translate(568.83 76.67) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.68,
    y: 240.01,
    width: 119.3,
    height: 165.48,
    transform: "translate(651.08 -5.58) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.84,
    y: 210.42,
    width: 34.97,
    height: 147.31,
    transform: "translate(612.4 -44.25) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.84,
    y: 248.52,
    width: 34.97,
    height: 147.31,
    transform: "translate(650.51 -6.15) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.84,
    y: 286.63,
    width: 34.97,
    height: 147.31,
    transform: "translate(688.61 31.96) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.93,266.13H295.72a3.63,3.63,0,0,0,3.63,3.62h58A3.62,3.62,0,0,0,360.93,266.13Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.93,304.23H295.72a3.63,3.63,0,0,0,3.63,3.63h58A3.62,3.62,0,0,0,360.93,304.23Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.93,342.34H295.72a3.63,3.63,0,0,0,3.63,3.62h58A3.62,3.62,0,0,0,360.93,342.34Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.75,
    y: 314.42,
    width: 119.3,
    height: 16.66,
    transform: "translate(742.15 -96.65) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.9,218c9.52-53.49,26.31-75.82,40-86C430.21,150,416.88,219.89,403.9,218Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.67,218c.3-42.3-9.39-61.78-18.41-71.54C392.18,162.18,392.46,217.61,402.67,218Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.9,218c4-59.52,18.48-85.55,31.06-98C423.17,141,417,218.87,403.9,218Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.92,225.68c1.19-59.49-6.74-88.29-14.31-103.32C396.1,145.62,395.12,223.67,403.92,225.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.92,225.68c10.33-63.57,6.82-95.9,1.55-113.4C408.39,138.41,395.43,221.92,403.92,225.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.78,213.66V251A12.15,12.15,0,0,0,403.9,263.1h0A12.16,12.16,0,0,0,416,251V213.66Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-26"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-26",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.09,145.82c-1.32,2.32-4.9-.68-6.2,3.28-1.05,3.17-3.37,3.09-4.13,6.77s.71,3.13-1.15,6.35c-1.36,2.35,1.07,3.47.11,6.2-.56,1.59-2.28,2.08-2.55,4s2.5,5.32,7,4.56c4.08-.69,5.72,2.36,9.08,1.33s4.63,3.59,10.3,1.61c4.48-1.56,4.16.13,6.68-.67s3.49-4.38,2.16-7.77c-.73-1.85-1.33-4.56.28-6.72s2.93-4.18,1.05-6.71c-2.07-2.77-1.72-4.6-1.76-7.49s-1.25-5.91-4.74-5.47c-3.1.4-6.54-.53-9.61-1.78C371,142.25,368.63,143.11,367.09,145.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.81 378.73 370.63 384.05 360.04 368.88 366.21 363.56 376.81 378.73",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.53,382.59l7.79-5.52a.77.77,0,0,1,.93,0l5.9,5.08a1.23,1.23,0,0,1-.11,1.94c-2.73,2-4.19,2.67-7.61,5.1-2.11,1.5-7.41,5.57-10.32,7.64s-5.4-.49-4.4-1.6c4.48-4.93,6.43-8.74,7-11.46A2,2,0,0,1,368.53,382.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.04 368.88 365.5 376.7 372.11 372.01 366.22 363.56 360.04 368.88",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.77,229.54s-12.37,47.26-18.1,78.21c-4.56,24.61,37.44,66.77,37.44,66.77L371,366.8s-21.19-32-30.17-54.11c13.53-33.31,32.64-63.84,28-79.24Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.34 363.8 358.02 373.12 361.76 376.93 373.41 368.39 370.34 363.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,386.36a3.07,3.07,0,0,1-1.76.7,1.13,1.13,0,0,1-.91-.48.57.57,0,0,1-.09-.57c.38-1,3.85-1.64,4.54-1.76a.18.18,0,0,1,.2.09.21.21,0,0,1,0,.23A13.32,13.32,0,0,1,366,386.36Zm-2.15-.49a.61.61,0,0,0-.26.28s0,.1,0,.19a.78.78,0,0,0,.62.34c.7,0,1.8-.69,3-1.94A11.19,11.19,0,0,0,363.8,385.87Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.87,384.6l-.07,0c-1.12.25-3.86.06-4.26-.76-.09-.18-.12-.46.25-.79,1.42-1.29,4,1.11,4.1,1.21a.21.21,0,0,1,.05.2A.26.26,0,0,1,367.87,384.6Zm-3.73-1.32-.1.08c-.15.14-.21.25-.17.34.24.47,2.22.75,3.46.61C366.66,383.77,365.07,382.62,364.14,383.28Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.12,184.75c-1.63,2.06-3.49,4.29-5.36,6.33s-3.8,4.11-5.82,6-4.09,3.73-6.24,5.41c-1.07.84-2.17,1.61-3.29,2.35-.56.37-1.13.72-1.7,1.06-.28.17-.57.32-.86.48l-.05,0a3,3,0,0,1-.28-.25,13.67,13.67,0,0,1-2-2.75,53.24,53.24,0,0,1-3.25-7.32c-1-2.56-1.87-5.21-2.68-7.88s-1.63-5.38-2.38-8.06l-4.05.81a118.16,118.16,0,0,0,3.19,17.11,55.5,55.5,0,0,0,3,8.5,20.06,20.06,0,0,0,2.66,4.35,8.71,8.71,0,0,0,2.64,2.19,6.54,6.54,0,0,0,2.25.71,6.37,6.37,0,0,0,2.61-.23,6.86,6.86,0,0,0,1.1-.42l.54-.27c.36-.18.73-.35,1.07-.54.71-.37,1.4-.75,2.08-1.16q2-1.2,3.95-2.54a68.61,68.61,0,0,0,7.17-5.78c2.25-2.05,4.41-4.18,6.44-6.4s4-4.47,5.85-7Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.64,192.6c-1.58,2.09-5.75,5.45-9,7.9-2.34,1.76-4.16,3.05-4.16,3.05l-1-1.24L333.2,192c3.95-5.47,8.69-11.2,16.66-10.81C354.87,181.45,358.47,188.87,355.64,192.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.67,200.5c-2.34,1.76-4.16,3.05-4.16,3.05l-1-1.24c1.41-2.24,3.82-5.67,5.95-6.69A11.63,11.63,0,0,1,346.67,200.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.24,182.07l1.82-7.12-6.94-1.14s.08,5.79,1.51,8.76Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.19 169.18 305.45 168.93 305.13 173.81 312.06 174.95 310.19 169.18",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.34 406 357.26 405.75 355.74 387.13 363.82 387.39 365.34 406",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.49,402.59l9.09-.17a.62.62,0,0,1,.64.54l1,7.1a1.32,1.32,0,0,1-1.3,1.44c-3.17,0-4.7-.15-8.7-.08-2.46.05-7.9.5-11.3.57s-3.55-3.26-2.13-3.59c6.35-1.46,9.22-3.48,11.37-5.29A2.15,2.15,0,0,1,356.49,402.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.82 387.39 355.74 387.14 356.53 396.73 364.61 396.99 363.82 387.39",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.08,234.61l-32.31-5.07c1-47.59,4.82-48.24,4.82-48.24s5.76-.32,11.48-.13c.86,0,1.73.07,2.58.13a104.72,104.72,0,0,1,14.67,2.29c.72.15,1.43.31,2.14.48a98.3,98.3,0,0,1,11.26,3.48c-2.38,5.46-4.33,10.12-5.93,14.22-2.1,5.34-3.61,9.69-4.76,13.53A124.34,124.34,0,0,0,375.08,234.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.65,181.3s-8.09,1.37-1.82,16.29c15.89-4.42,16.5-14,16.5-14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,215.3c-.65-5.11,1.45-15.13,3.85-18.09l.91,4.56C381.69,207.11,380.18,211.46,379,215.3Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.91,173.24c-.94,3.91-1.28,8.07.42,10.36,0,0-2.55,7-15.33,10.57-5.79-10.74.65-12.87.65-12.87,5.5-.43,6.25-3.88,5.9-9.9l4.49-.94A2.57,2.57,0,0,1,375.91,173.24Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,170.46a2.57,2.57,0,0,1,3.93,2.42,16.79,16.79,0,0,1-8.88,4.88,17.26,17.26,0,0,0,.47-6.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.84,160.47c-2.87,7.54-3.93,10.78-9,13.61-7.64,4.26-16.16-.66-15.58-8.84.53-7.36,5.14-18.44,13.53-19.35A10.6,10.6,0,0,1,383.84,160.47Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.05,168.84a6.1,6.1,0,0,1-4.21,1.65c-2.06,0-2.45-2-1.35-3.61,1-1.45,3.27-3.18,5.08-2.37S384.43,167.51,383.05,168.84Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.21,146.21c-1.75,1.17-1.33,4.91,2.67,4.79,3.69-.11,5.56,2.16,5.45,4.79s.81,3.13,2.06,5-1.36,5.14,1.53,6.31c3.62,1.46,6.46-5.1,6.16-10.14s-.77-8-4.75-10.13C377.62,144.83,373.42,142.71,368.21,146.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.71,149.1h0a1.06,1.06,0,0,1-1.36-.64l-.53-1.5a1,1,0,0,1,.65-1.35h0a1.05,1.05,0,0,1,1.35.64l.53,1.49A1.06,1.06,0,0,1,367.71,149.1Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.4,159.8a3.75,3.75,0,1,1-3.75-3.75A3.74,3.74,0,0,1,374.4,159.8Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.44,157a3.75,3.75,0,1,1-3.75-3.74A3.74,3.74,0,0,1,365.44,157Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.51,164.58a.18.18,0,0,1-.1,0l-8.19-3.8a.25.25,0,0,1-.12-.33.24.24,0,0,1,.33-.12l8.19,3.8a.25.25,0,0,1-.11.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.48,158.05a.25.25,0,0,1-.19-.09c-.89-1.13-1.71-.76-1.74-.75a.24.24,0,0,1-.33-.11.25.25,0,0,1,.11-.33c.05,0,1.2-.59,2.35.88a.24.24,0,0,1,0,.35A.24.24,0,0,1,367.48,158.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.67,250.66l-4.56,3.51c-5.6,10.06-6,25.41-4.23,40.05,7.63-16.62,15.25-31.85,18.7-43.92l.23-1.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.8,230.75s1.86,55,1,86.32c3.09,26,3.88,75.18,3.88,75.18l11.1-.58s5.52-57.11,2.78-75.78c6.08-34.7,14.24-65.31,6.55-81.27Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.27 394.58 367.26 394.38 368.1 388.87 352.4 389.55 353.27 394.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.92,232.81l.92,3.1c.07.24-.24.43-.61.37L342.34,231c-.29,0-.51-.22-.49-.41l.24-2.92c0-.2.3-.33.62-.28l32.72,5.13A.6.6,0,0,1,375.92,232.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.84,235.75l.88.14c.18,0,.33,0,.33-.15l.29-3.8c0-.11-.13-.23-.31-.25l-.87-.14c-.18,0-.33,0-.33.15l-.29,3.8C370.53,235.61,370.67,235.73,370.84,235.75Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.74,231.66l.88.14c.17,0,.32,0,.33-.15l.28-3.8c0-.12-.12-.23-.3-.26l-.87-.13c-.18,0-.33,0-.34.15l-.28,3.8C344.43,231.52,344.57,231.63,344.74,231.66Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.79,233.71l.88.14c.18,0,.32,0,.33-.16l.29-3.8c0-.11-.13-.22-.31-.25l-.87-.14c-.18,0-.33,0-.34.16l-.28,3.8C357.48,233.57,357.62,233.68,357.79,233.71Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,159.43c-.19.62-.68,1-1.09.92s-.57-.72-.37-1.34.68-1,1.08-.92S372.16,158.8,372,159.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,157.41c-.2.63-.69,1-1.09.92s-.58-.71-.38-1.34.68-1,1.09-.92S365.16,156.79,365,157.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.75,156.16l-1.35-.86S363.8,156.69,364.75,156.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.71,159.07a18.22,18.22,0,0,1-3.85,2.88,2.7,2.7,0,0,0,1.92,1.31Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.11,166.34a.19.19,0,0,1-.06-.2.2.2,0,0,1,.24-.13,5.23,5.23,0,0,0,4.61-.79.2.2,0,0,1,.26,0,.19.19,0,0,1,0,.27,5.53,5.53,0,0,1-5,.86A.15.15,0,0,1,366.11,166.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.05,157.15a.4.4,0,0,1-.12-.16A2.92,2.92,0,0,0,373,155.1a.38.38,0,0,1-.28-.46.4.4,0,0,1,.46-.29,3.62,3.62,0,0,1,2.48,2.37.39.39,0,0,1-.23.49A.38.38,0,0,1,375.05,157.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,151.76s0,0,0-.06a.4.4,0,0,1,.31-.45,3.66,3.66,0,0,1,3.35.87.39.39,0,0,1-.56.53A3,3,0,0,0,362,152,.37.37,0,0,1,361.56,151.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.27,403.73l-.1-.08a1.06,1.06,0,0,1-.31-1,.68.68,0,0,1,.39-.54c.94-.44,3.39,1.08,3.66,1.26a.18.18,0,0,1,.09.19.21.21,0,0,1-.15.15C354.85,404,353.08,404.29,352.27,403.73Zm3-.28c-1-.58-2.41-1.23-2.91-1a.29.29,0,0,0-.16.24.71.71,0,0,0,.19.67C352.84,403.73,353.9,403.75,355.31,403.45Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.53,403.58c-.79-.55-2-2.07-1.85-2.91a.67.67,0,0,1,.65-.54,1,1,0,0,1,.8.24c.88.75.87,3.06.87,3.15a.19.19,0,0,1-.1.17.17.17,0,0,1-.19,0Zm-.71-3a.6.6,0,0,0-.45-.11c-.25,0-.3.15-.32.24-.11.55.79,1.83,1.56,2.42a4.22,4.22,0,0,0-.73-2.5Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.75,158.17l-1.35-.86S370.8,158.7,371.75,158.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,192.9c.53,1.46.94,2.75,1.34,4.14s.75,2.73,1.08,4.11c.64,2.76,1.15,5.55,1.53,8.39a69.74,69.74,0,0,1,.62,8.59c0,.72,0,1.45,0,2.18s0,1.45-.09,2.19-.09,1.42-.18,2.23l-.17,1.28-.28,1.24a28.25,28.25,0,0,1-4,8.56,51.86,51.86,0,0,1-5.62,6.87,86.1,86.1,0,0,1-6.35,5.91,82.88,82.88,0,0,1-6.92,5.16l-2.43-3.2c2-1.8,4-3.72,5.8-5.69s3.67-4,5.32-6.06a51.65,51.65,0,0,0,4.41-6.42,31.61,31.61,0,0,0,1.64-3.3,20.06,20.06,0,0,0,1-3.26l.14-.78.06-.76c0-.56,0-1.25,0-1.87s0-1.27,0-1.91,0-1.28-.08-1.92c-.15-2.56-.52-5.13-.91-7.69s-1-5.12-1.59-7.64c-.3-1.27-.63-2.53-1-3.78s-.75-2.54-1.12-3.64Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.72,187.55c3.68,1.63,6,14,6,14l-12.85,6.73s-4.76-10.69-3-15.61C381.48,188.52,385,185.46,389.72,187.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.28 254.37 362.35 259.14 367.7 256.78 363.6 249.57 358.28 254.37",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.83,249l-7.23.55,4.1,7.21s4-2.14,5.23-5.28Z",
    style: {
      fill: "#ff8b7b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Smartphone--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.08,146.16H209a12,12,0,0,0-12,12V346.07a12,12,0,0,0,12,12h86.11a12,12,0,0,0,12-12V158.16A12,12,0,0,0,295.08,146.16Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,146.16H207.48a12,12,0,0,0-12,12V346.07a12,12,0,0,0,12,12h86.11a12,12,0,0,0,12-12V158.16A12,12,0,0,0,293.59,146.16Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,146.16H207.48a12,12,0,0,0-12,12V346.07a12,12,0,0,0,12,12h86.11a12,12,0,0,0,12-12V158.16A12,12,0,0,0,293.59,146.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.48,346.07V158.16a12,12,0,0,1,12-12h-2a12,12,0,0,0-12,12V346.07a12,12,0,0,0,12,12h2A12,12,0,0,1,197.48,346.07Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,325.44H269.4a2.77,2.77,0,0,1-2.76-2.77v-12a2.51,2.51,0,0,0-2.51-2.51H236.62a2.77,2.77,0,0,1-2.76-2.77V164.93a2.77,2.77,0,0,1,2.76-2.77h54.73a2.77,2.77,0,0,1,2.76,2.77V305.42a2.77,2.77,0,0,1-2.76,2.77h-4a2.51,2.51,0,0,0-2.51,2.51v12A2.77,2.77,0,0,1,282.13,325.44Zm-45.51-163a2.52,2.52,0,0,0-2.51,2.52V305.42a2.52,2.52,0,0,0,2.51,2.52h27.51a2.77,2.77,0,0,1,2.76,2.76v12a2.51,2.51,0,0,0,2.51,2.52h12.73a2.52,2.52,0,0,0,2.51-2.52v-12a2.77,2.77,0,0,1,2.76-2.76h4a2.52,2.52,0,0,0,2.51-2.52V164.93a2.52,2.52,0,0,0-2.51-2.52Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,298.35h-1.72a2.76,2.76,0,0,1-2.76-2.76V164.93a2.77,2.77,0,0,1,2.76-2.77H225a2.77,2.77,0,0,1,2.77,2.77V295.59A2.76,2.76,0,0,1,225,298.35Zm-1.72-135.94a2.51,2.51,0,0,0-2.51,2.52V295.59a2.51,2.51,0,0,0,2.51,2.51H225a2.51,2.51,0,0,0,2.52-2.51V164.93a2.52,2.52,0,0,0-2.52-2.52Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.15,353.44a4.21,4.21,0,1,1,4.21-4.21A4.22,4.22,0,0,1,209.15,353.44Zm0-8.17a4,4,0,1,0,4,4A4,4,0,0,0,209.15,345.27Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.4,353.44a4.21,4.21,0,1,1,4.21-4.21A4.22,4.22,0,0,1,293.4,353.44Zm0-8.17a4,4,0,1,0,4,4A4,4,0,0,0,293.4,345.27Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.98,
    y: 181.73,
    width: 7.17,
    height: 8.33,
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.32,
    y: 199.06,
    width: 7.17,
    height: 8.33,
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.98,
    y: 267.9,
    width: 7.17,
    height: 8.33,
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.04,
    y: 174.73,
    width: 64.33,
    height: 143.15,
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.26,
    y: 174.73,
    width: 47,
    height: 115.27,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.37,
    y: 174.73,
    width: 3.33,
    height: 143.15,
    transform: "translate(560.08 492.61) rotate(180)",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.37,
    y: 174.73,
    width: 3.33,
    height: 143.15,
    transform: "translate(560.08 492.61) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.71,
    y: 303.22,
    width: 6.58,
    height: 8.25,
    rx: 0.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.71,
    y: 303.22,
    width: 6.58,
    height: 8.25,
    rx: 0.75,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.8,
    y: 289.3,
    width: 7.21,
    height: 18.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.8,
    y: 289.3,
    width: 7.21,
    height: 18.04,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.73,
    y: 290.72,
    width: 3.28,
    height: 15.21,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,124.9H146.09a12,12,0,0,0-12,12V324.81a12,12,0,0,0,12,12H232.2a12,12,0,0,0,12-12V136.9A12,12,0,0,0,232.2,124.9Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,124.9H146.09a12,12,0,0,0-12,12V324.81a12,12,0,0,0,12,12H232.2a12,12,0,0,0,12-12V136.9A12,12,0,0,0,232.2,124.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.31,124.9H141.2a12,12,0,0,0-12,12V324.81a12,12,0,0,0,12,12h86.11a12,12,0,0,0,12-12V136.9A12,12,0,0,0,227.31,124.9Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.64,
    y: 144.14,
    width: 105.22,
    height: 177.56,
    rx: 2.97,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.72,327.71h-2a4.63,4.63,0,0,0-9,0h-2v2.08h2a4.63,4.63,0,0,0,9,0h2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.22,328.75a2,2,0,1,1-2-2A2,2,0,0,1,186.22,328.75Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.14,
    y: 324.97,
    width: 4.64,
    height: 4.64,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.89 336.81 207.39 336.81 207.39 332.42 203.25 332.42 203.25 336.81 202.75 336.81 202.75 331.92 207.89 331.92 207.89 336.81",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.67 330.94 141.53 330.94 141.53 321.69 142.03 321.69 142.03 330.44 146.17 330.44 146.17 321.69 146.67 321.69 146.67 330.94",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 329.05,
    width: 2.58,
    height: 2.58,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.45,
    y: 324.19,
    width: 1.06,
    height: 2.58,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.35,
    y: 324.19,
    width: 1.06,
    height: 2.58,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.25,
    y: 324.19,
    width: 1.06,
    height: 2.58,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.89,
    y: 284.69,
    width: 4.14,
    height: 29.56,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.89,
    y: 240.39,
    width: 4.14,
    height: 10.49,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.31,225.64h0V203.3h0a1.78,1.78,0,0,1,1.78,1.78v18.77A1.79,1.79,0,0,1,239.31,225.64Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.31,188.14h0V179.8h0a1.78,1.78,0,0,1,1.78,1.78v4.77A1.79,1.79,0,0,1,239.31,188.14Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.25,130.11v9.28a1,1,0,0,1-1,1H207.22a1,1,0,0,1-1-1v-2a1,1,0,0,0-1-1h-21.6a1,1,0,0,0-.72.31l-1.57,1.74a1,1,0,0,1-1.69-.66v-7.73a1,1,0,0,1,1-1h43.61A1,1,0,0,1,225.25,130.11Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.89,
    y: 156.83,
    width: 4.14,
    height: 10.49,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.81,
    y: 130.51,
    width: 4.14,
    height: 5.65,
    rx: 0.81,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.92,140.52H147.7V137h-3.56v-6.71h24.22v3.56h3.56ZM148.2,140h23.22v-5.7h-3.56v-3.56H144.64v5.71h3.56Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.93,
    y: 133.34,
    width: 4.14,
    height: 5.65,
    rx: 0.81,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.89,138.22h-5.44v-5.78h5.44Zm-4.94-.5h4.44v-4.78H150Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.88,328.74a7.05,7.05,0,1,1,7.05-7.05A7.05,7.05,0,0,1,204.88,328.74Zm0-13.85a6.8,6.8,0,1,0,6.8,6.8A6.81,6.81,0,0,0,204.88,314.89Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.78,147.37a3.24,3.24,0,1,1,3.23-3.23A3.23,3.23,0,0,1,141.78,147.37Zm0-6.22a3,3,0,1,0,3,3A3,3,0,0,0,141.78,141.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.19,103.64H77.08a12,12,0,0,0-12,12V303.55a12,12,0,0,0,12,12h86.11a12,12,0,0,0,12-12V115.64A12,12,0,0,0,163.19,103.64ZM65.74,297.46V125.85a3,3,0,0,1,3-3H168a3,3,0,0,1,3,3V297.46a3,3,0,0,1-3,3H68.72A3,3,0,0,1,65.74,297.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.41,103.64H75.3a12,12,0,0,0-12,12V303.55a12,12,0,0,0,12,12h86.11a12,12,0,0,0,12-12V115.64A12,12,0,0,0,161.41,103.64ZM168,300.44H68.72a3,3,0,0,1-3-3V125.85a3,3,0,0,1,3-3H168a3,3,0,0,1,3,3V297.46A3,3,0,0,1,168,300.44Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.75,
    y: 122.88,
    width: 105.22,
    height: 177.56,
    rx: 2.97,
    style: {
      fill: "#38B2AC",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,307.49a4.64,4.64,0,1,1-4.64-4.64A4.64,4.64,0,0,1,123,307.49Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.52,115.77H107.19a1.89,1.89,0,0,1-1.89-1.89h0a1.89,1.89,0,0,1,1.89-1.89h22.33a1.89,1.89,0,0,1,1.89,1.89h0A1.89,1.89,0,0,1,129.52,115.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.24,123.13h-.07L181,109.29a.25.25,0,0,1-.16-.31.24.24,0,0,1,.31-.17l46.12,13.83a.25.25,0,0,1,.17.31A.25.25,0,0,1,227.24,123.13Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.52,109a.86.86,0,0,1,0-1.71.86.86,0,1,1,0,1.71Zm0-1.21a.36.36,0,1,0,.36.36A.36.36,0,0,0,178.52,107.77Z",
    style: {
      fill: "#38B2AC",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,143.6h-.07l-42.76-12.76a.24.24,0,0,1-.16-.31.26.26,0,0,1,.31-.17L293,143.11a.25.25,0,0,1,.17.31A.26.26,0,0,1,293,143.6Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.34,130.34a.86.86,0,0,1-.85-.86.85.85,0,0,1,.85-.85.86.86,0,1,1,0,1.71Zm0-1.21a.36.36,0,0,0,0,.71.36.36,0,1,0,0-.71Z",
    style: {
      fill: "#38B2AC",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.88,334.5h-.07L79.68,320.66a.25.25,0,0,1-.16-.31.25.25,0,0,1,.31-.17L126,334a.25.25,0,0,1-.07.49Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.16,320.35a.85.85,0,0,1-.85-.85.86.86,0,1,1,.85.85Zm0-1.21a.36.36,0,1,0,.36.36A.36.36,0,0,0,77.16,319.14Z",
    style: {
      fill: "#38B2AC",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.61,355h-.07l-42.75-12.75a.24.24,0,0,1-.17-.31.24.24,0,0,1,.31-.17l42.75,12.75a.25.25,0,0,1-.07.49Z",
    style: {
      fill: "#38B2AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,341.71a.86.86,0,1,1,.85-.85A.85.85,0,0,1,146,341.71Zm0-1.21a.36.36,0,1,0,0,.71.36.36,0,0,0,0-.71Z",
    style: {
      fill: "#38B2AC",
      opacity: 0.30000000000000004
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDownload);
export default __webpack_public_path__ + "static/media/mobileDownload.873f3dbdf7512a21fde5cdde6ef83ad6.svg";
export { ForwardRef as ReactComponent };